import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PaginationCalculation } from "app/pagination/pagination-calculation";

@Component({
	selector: 'vbn-pagination',
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

	pc: PaginationCalculation
	nrOfPages: number
	visiblePages: number = 5
	@Input()
	set configPagination(config: any) {
		console.log("configPagination")
		this.nrOfPages = config.cap
		if(this.pc === undefined) {
			this.pc = new PaginationCalculation(this.visiblePages, this.nrOfPages, config.start)
		} else {
			this.pc.build(this.visiblePages, this.nrOfPages,  config.start)
		}

	}

	@Output() goToPage = new EventEmitter();


	constructor() {
	}

	next() {
		let curPage = this.pc.curPage
		this.pc.build(this.visiblePages, this.nrOfPages, curPage + 1)
		this.goToPage.emit(this.pc.curPage)
	}

	prev() {
		let curPage = this.pc.curPage
		this.pc.build(this.visiblePages, this.nrOfPages, curPage - 1)
		this.goToPage.emit(this.pc.curPage)
	}

	goTo(index) {
		this.pc.build(this.visiblePages, this.nrOfPages, index)
		this.goToPage.emit(this.pc.curPage)
	}


	ngOnInit() {
	}

}
